export default {
    zh: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 视频生成器 - AI舞蹈视频创作',
        pageDescription: '体验ByteDance的Seedance视频生成器，专注于舞蹈视频创作、动作生成和多样化风格功能。在WeryAI平台免费创建专业AI舞蹈视频。',
        pageKeywords: 'Seedance, AI视频生成器, 舞蹈视频创作, 动作生成, 音乐同步, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro 视频生成器',
        generatorDescription: 'Seedance 是 ',
        generatorDescriptionHighlight1: 'ByteDance 推出的新 AI 视频生成模型',
        generatorDescriptionText2: '，由 Pixeldance 和 Seedweed 开发团队合并而成。Seedance 1.0 最近在',
        generatorDescriptionHighlight2: '视频竞技场排行榜上稳居榜首',
        generatorDescriptionText3: '。该工具具有',
        generatorDescriptionHighlight3: '多镜头能力、流畅且导向性强的摄像机移动',
        generatorDescriptionText4: '等功能！使用 ',
        generatorDescriptionHighlight4: '微鲤AI 中的 Seedance 创建 AI 视频',
        generatorDescriptionEnd: '。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro 的主要功能',

        // 精准的语义理解
        accurateSemanticTitle: '精准的语义理解',
        accurateSemanticDescription: '精准解读复杂的用户提示',

        // 动态摄像机控制
        dynamicCameraControlTitle: '动态摄像机控制',
        dynamicCameraControlDescription: '包括缩放、平移和跟踪',

        // 多镜头生成保持一致
        multiShotGenerationTitle: '多镜头生成保持一致',
        multiShotGenerationDescription: '生成多个镜头，并保持一致性',

        // 支持多种风格
        multipleStylesTitle: '支持多种风格',
        multipleStylesDescription: '支持多种艺术风格和主题',

        // 如何使用部分
        howToUseTitle: 'How to Use',
        step1Title: '选择Seedance模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Seedance"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的舞蹈创意',
        step2Description: '描述您想要生成的舞蹈风格和动作，或上传参考图片，并选择您喜欢的音乐和节奏。',
        step3Title: '下载您的舞蹈视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的精彩舞蹈视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Seedance是什么?',
        faq1Answer: 'Seedance是一款创新的AI视频生成平台，专注于舞蹈视频创作和动作生成。它采用先进的深度学习技术，能够生成流畅、自然的舞蹈和动作视频内容。',
        faq2Question: 'Seedance有哪些主要功能?',
        faq2Answer: 'Seedance主要功能包括：舞蹈视频创作、动作生成、多样化风格、音乐同步等。它专门针对舞蹈视频生成进行了优化，支持各种风格的舞蹈动作，从古典芭蕾到现代街舞。',
        faq3Question: '我能免费使用Seedance吗?',
        faq3Answer: '是的。Seedance通过WeryAI的免费试用提供有限的免费额度。如需大量使用，则需要升级。',
        faq4Question: 'Seedance支持哪些舞蹈风格?',
        faq4Answer: 'Seedance支持多种舞蹈和动作风格，包括古典舞、现代舞、街舞、民族舞等，让您能够创作出风格各异的精彩视频内容。',
        faq5Question: '我可以使用 Seedance用于专业或商业项目吗?',
        faq5Answer: '是的。Seedance的高质量舞蹈视频生成和强大的动作生成功能使其成为专业舞蹈创作者、内容创作者和商业用户的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance，将您的舞蹈创意转化为精彩视频',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dance Video Creation',
        pageDescription: 'Experience Seedance video generator by ByteDance with dance video creation, motion generation, and diverse style features. Create professional AI dance videos for free on 微鲤AI platform.',
        pageKeywords: 'Seedance, AI video generator, dance video creation, motion generation, music synchronization, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'a new AI video generation model launched by ByteDance',
        generatorDescriptionText2: ', formed by the merger of Pixeldance and Seedweed development teams. Seedance 1.0 recently ',
        generatorDescriptionHighlight2: 'ranks first on the Video Arena leaderboard',
        generatorDescriptionText3: '. The tool features ',
        generatorDescriptionHighlight3: 'multi-shot capabilities, smooth and directed camera movement',
        generatorDescriptionText4: ' and more! Use ',
        generatorDescriptionHighlight4: 'Seedance on 微鲤AI to create AI videos',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Accurate Semantic Understanding',
        accurateSemanticDescription: 'Precisely interprets complex user prompts',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamic Camera Control',
        dynamicCameraControlDescription: 'Including zoom, pan, and tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-Shot Generation with Consistency',
        multiShotGenerationDescription: 'Generates multiple shots while maintaining consistency',

        // Support for multiple styles
        multipleStylesTitle: 'Support for Multiple Styles',
        multipleStylesDescription: 'Supports various artistic styles and themes',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Seedance Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Seedance" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Dance Creative Ideas',
        step2Description: 'Describe the dance style and movements you want to generate, or upload reference images, and choose your preferred music and rhythm.',
        step3Title: 'Download Your Dance Video',
        step3Description: 'Click "Create" to download or share the generated spectacular dance video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Seedance?',
        faq1Answer: 'Seedance is an innovative AI video generation platform focused on dance video creation and motion generation. It uses advanced deep learning technology to generate smooth, natural dance and motion video content.',
        faq2Question: 'What are the main features of Seedance?',
        faq2Answer: 'Seedance\'s main features include: dance video creation, motion generation, diverse styles, music synchronization, etc. It is specially optimized for dance video generation and supports various dance styles, from classical ballet to modern street dance.',
        faq3Question: 'Can I use Seedance for free?',
        faq3Answer: 'Yes. Seedance provides limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What dance styles does Seedance support?',
        faq4Answer: 'Seedance supports various dance and motion styles, including classical dance, modern dance, street dance, folk dance, etc., allowing you to create diverse and spectacular video content.',
        faq5Question: 'Can I use Seedance for professional or commercial projects?',
        faq5Answer: 'Yes. Seedance\'s high-quality dance video generation and powerful motion generation capabilities make it a strong choice for professional dance creators, content creators, and commercial users.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance now and transform your dance ideas into amazing videos',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 動画ジェネレーター - AIダンス動画作成',
        pageDescription: 'ByteDanceのSeedance動画ジェネレーターを体験。ダンス動画作成、モーション生成、多様なスタイル機能。WeryAIプラットフォームで無料でプロフェッショナルなAIダンス動画を作成。',
        pageKeywords: 'Seedance, AI動画ジェネレーター, ダンス動画作成, モーション生成, 音楽同期, 無料AI動画, 微鲤AI, 動画制作',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro 動画ジェネレーター',
        generatorDescription: 'Seedanceは',
        generatorDescriptionHighlight1: 'ByteDanceが発表した新しいAI動画生成モデル',
        generatorDescriptionText2: 'で、PixeldanceとSeedweed開発チームが統合されて形成されました。Seedance 1.0は最近',
        generatorDescriptionHighlight2: '動画アリーナランキングで首位を維持',
        generatorDescriptionText3: 'しています。このツールは',
        generatorDescriptionHighlight3: 'マルチショット機能、スムーズで方向性のあるカメラ移動',
        generatorDescriptionText4: 'などの機能を備えています！',
        generatorDescriptionHighlight4: 'WeryAIのSeedanceでAI動画を作成',
        generatorDescriptionEnd: 'しましょう。',
        
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',
        coreFeaturesTitle: 'Seedance 1.0 Proの主な機能',
        accurateSemanticTitle: '正確なセマンティック理解',
        accurateSemanticDescription: '複雑なユーザープロンプトを正確に解釈',
        dynamicCameraControlTitle: 'ダイナミックカメラコントロール',
        dynamicCameraControlDescription: 'ズーム、パン、トラッキングを含む',
        multiShotGenerationTitle: '一貫性のあるマルチショット生成',
        multiShotGenerationDescription: '複数のショットを生成し、一貫性を維持',
        multipleStylesTitle: '複数のスタイルをサポート',
        multipleStylesDescription: '様々な芸術スタイルとテーマをサポート',
        howToUseTitle: 'How to Use',
        step1Title: 'Seedanceモデルを選択',
        step1Description: '「AI動画生成」ページに移動し、モデルドロップダウンメニューで「Seedance」をクリックします。',
        step2Title: 'ダンスのアイデアを入力',
        step2Description: '生成したいダンススタイルと動きを説明するか、参照画像をアップロードし、お好みの音楽とリズムを選択します。',
        step3Title: 'ダンス動画をダウンロード',
        step3Description: '「作成」をクリックして、生成された素晴らしいダンス動画をダウンロードまたは共有します。',
        youtubeTitle: 'SeedanceモデルについてのYouTube動画',
        xPostsTitle: 'Seedanceモデルについての人気X投稿',
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: 'よくある質問',
        faq1Question: 'Seedanceとは何ですか？',
        faq1Answer: 'Seedanceは、ダンス動画作成とモーション生成に特化した革新的なAI動画生成プラットフォームです。先進的な深層学習技術を使用し、滑らかで自然なダンスとモーション動画コンテンツを生成します。',
        faq2Question: 'Seedanceの主な機能は何ですか？',
        faq2Answer: 'Seedanceの主な機能には、ダンス動画作成、モーション生成、多様なスタイル、音楽同期などが含まれます。ダンス動画生成に特化して最適化されており、クラシックバレエから現代ストリートダンスまで、様々なスタイルのダンス動作をサポートします。',
        faq3Question: 'Seedanceを無料で使用できますか？',
        faq3Answer: 'はい。SeedanceはWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        faq4Question: 'Seedanceはどのようなダンススタイルをサポートしていますか？',
        faq4Answer: 'Seedanceは、クラシックダンス、現代ダンス、ストリートダンス、民族舞踊など、様々なダンスとモーションスタイルをサポートしており、スタイルの異なる素晴らしい動画コンテンツを作成できます。',
        faq5Question: 'Seedanceをプロフェッショナルまたは商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。Seedanceの高品質ダンス動画生成と強力なモーション生成機能は、プロのダンスクリエーター、コンテンツクリエーター、ビジネスユーザーにとって強力な選択肢となります。',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐSeedanceを体験し、あなたのダンスアイデアを素晴らしい動画に変換',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
            step1DescriptionHighlight: '', // Pending alignment
    },
    ko: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 비디오 생성기 - AI 댄스 비디오 제작',
        pageDescription: 'ByteDance의 Seedance 비디오 생성기를 체험하세요. 댄스 비디오 제작, 모션 생성, 다양한 스타일 기능. 微鲤AI 플랫폼에서 무료로 전문적인 AI 댄스 비디오를 제작하세요.',
        pageKeywords: 'Seedance, AI 비디오 생성기, 댄스 비디오 제작, 모션 생성, 음악 동기화, 무료 AI 비디오, 微鲤AI, 비디오 제작',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro 비디오 생성기',
        generatorDescription: 'Seedance는 ',
        generatorDescriptionHighlight1: 'ByteDance가 출시한 새로운 AI 비디오 생성 모델',
        generatorDescriptionText2: '로, Pixeldance와 Seedweed 개발팀이 합병하여 형성되었습니다. Seedance 1.0은 최근 ',
        generatorDescriptionHighlight2: '비디오 아레나 순위에서 1위를 유지',
        generatorDescriptionText3: '하고 있습니다. 이 도구는 ',
        generatorDescriptionHighlight3: '멀티샷 기능, 부드럽고 방향성 있는 카메라 이동',
        generatorDescriptionText4: ' 등의 기능을 갖추고 있습니다! ',
        generatorDescriptionHighlight4: 'WeryAI의 Seedance로 AI 비디오 생성',
        generatorDescriptionEnd: '하세요.',
        
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',
        coreFeaturesTitle: 'Seedance 1.0 Pro의 주요 기능',
        accurateSemanticTitle: '정확한 의미 이해',
        accurateSemanticDescription: '복잡한 사용자 프롬프트를 정확하게 해석',
        dynamicCameraControlTitle: '동적 카메라 제어',
        dynamicCameraControlDescription: '줌, 팬, 트래킹 포함',
        multiShotGenerationTitle: '일관성 있는 멀티샷 생성',
        multiShotGenerationDescription: '여러 샷을 생성하면서 일관성 유지',
        multipleStylesTitle: '다양한 스타일 지원',
        multipleStylesDescription: '다양한 예술 스타일과 테마 지원',
        howToUseTitle: 'How to Use',
        step1Title: 'Seedance 모델 선택',
        step1Description: '"AI 비디오 생성" 페이지로 이동한 후 모델 드롭다운 메뉴에서 "Seedance"를 클릭합니다.',
        step2Title: '댄스 아이디어 입력',
        step2Description: '생성하려는 댄스 스타일과 동작을 설명하거나 참조 이미지를 업로드하고 원하는 음악과 리듬을 선택합니다.',
        step3Title: '댄스 비디오 다운로드',
        step3Description: '"만들기"를 클릭하여 생성된 멋진 댄스 비디오를 다운로드하거나 공유합니다.',
        youtubeTitle: 'Seedance 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Seedance 모델에 대한 인기 X 게시물',
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Seedance가 무엇인가요?',
        faq1Answer: 'Seedance는 댄스 비디오 제작과 모션 생성에 특화된 혁신적인 AI 비디오 생성 플랫폼입니다. 고급 딥러닝 기술을 사용하여 부드럽고 자연스러운 댄스와 모션 비디오 콘텐츠를 생성합니다.',
        faq2Question: 'Seedance의 주요 기능은 무엇인가요?',
        faq2Answer: 'Seedance의 주요 기능에는 댄스 비디오 제작, 모션 생성, 다양한 스타일, 음악 동기화 등이 포함됩니다. 댄스 비디오 생성에 특화되어 최적화되었으며, 클래식 발레부터 현대 스트리트 댄스까지 다양한 스타일의 댄스 동작을 지원합니다.',
        faq3Question: 'Seedance를 무료로 사용할 수 있나요?',
        faq3Answer: '네. Seedance는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용의 경우 업그레이드가 필요합니다.',
        faq4Question: 'Seedance는 어떤 댄스 스타일을 지원하나요?',
        faq4Answer: 'Seedance는 클래식 댄스, 현대 댄스, 스트리트 댄스, 민속 무용 등 다양한 댄스와 모션 스타일을 지원하여 스타일이 다양한 멋진 비디오 콘텐츠를 만들 수 있습니다.',
        faq5Question: 'Seedance를 전문적 또는 상업적 프로젝트에 사용할 수 있나요?',
        faq5Answer: '네. Seedance의 고품질 댄스 비디오 생성과 강력한 모션 생성 기능은 전문 댄스 크리에이터, 콘텐츠 크리에이터, 비즈니스 사용자에게 강력한 선택이 됩니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Seedance를 체험하고 당신의 댄스 아이디어를 놀라운 비디오로 변환하세요',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
            step1DescriptionHighlight: '', // Pending alignment
    },
    tw: {

        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 视频生成器 - AI舞蹈视频创作',
        pageDescription: '体验ByteDance的Seedance视频生成器，专注于舞蹈视频创作、动作生成和多样化风格功能。在WeryAI平台免费创建专业AI舞蹈视频。',
        pageKeywords: 'Seedance, AI视频生成器, 舞蹈视频创作, 动作生成, 音乐同步, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro 视频生成器',
        generatorDescription: 'Seedance 是 ',
        generatorDescriptionHighlight1: 'ByteDance 推出的新 AI 视频生成模型',
        generatorDescriptionText2: '，由 Pixeldance 和 Seedweed 开发团队合并而成。Seedance 1.0 最近在',
        generatorDescriptionHighlight2: '视频竞技场排行榜上稳居榜首',
        generatorDescriptionText3: '。该工具具有',
        generatorDescriptionHighlight3: '多镜头能力、流畅且导向性强的摄像机移动',
        generatorDescriptionText4: '等功能！使用 ',
        generatorDescriptionHighlight4: '微鲤AI 中的 Seedance 创建 AI 视频',
        generatorDescriptionEnd: '。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro 的主要功能',

        // 精准的语义理解
        accurateSemanticTitle: '精准的语义理解',
        accurateSemanticDescription: '精准解读复杂的用户提示',

        // 动态摄像机控制
        dynamicCameraControlTitle: '动态摄像机控制',
        dynamicCameraControlDescription: '包括缩放、平移和跟踪',

        // 多镜头生成保持一致
        multiShotGenerationTitle: '多镜头生成保持一致',
        multiShotGenerationDescription: '生成多个镜头，并保持一致性',

        // 支持多种风格
        multipleStylesTitle: '支持多种风格',
        multipleStylesDescription: '支持多种艺术风格和主题',

        // 如何使用部分
        howToUseTitle: 'How to Use',
        step1Title: '选择Seedance模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Seedance"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的舞蹈创意',
        step2Description: '描述您想要生成的舞蹈风格和动作，或上传参考图片，并选择您喜欢的音乐和节奏。',
        step3Title: '下载您的舞蹈视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的精彩舞蹈视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Seedance是什么?',
        faq1Answer: 'Seedance是一款创新的AI视频生成平台，专注于舞蹈视频创作和动作生成。它采用先进的深度学习技术，能够生成流畅、自然的舞蹈和动作视频内容。',
        faq2Question: 'Seedance有哪些主要功能?',
        faq2Answer: 'Seedance主要功能包括：舞蹈视频创作、动作生成、多样化风格、音乐同步等。它专门针对舞蹈视频生成进行了优化，支持各种风格的舞蹈动作，从古典芭蕾到现代街舞。',
        faq3Question: '我能免费使用Seedance吗?',
        faq3Answer: '是的。Seedance通过WeryAI的免费试用提供有限的免费额度。如需大量使用，则需要升级。',
        faq4Question: 'Seedance支持哪些舞蹈风格?',
        faq4Answer: 'Seedance支持多种舞蹈和动作风格，包括古典舞、现代舞、街舞、民族舞等，让您能够创作出风格各异的精彩视频内容。',
        faq5Question: '我可以使用 Seedance用于专业或商业项目吗?',
        faq5Answer: '是的。Seedance的高质量舞蹈视频生成和强大的动作生成功能使其成为专业舞蹈创作者、内容创作者和商业用户的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance，将您的舞蹈创意转化为精彩视频',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dance Video Creation',
        pageDescription: 'Experience Seedance video generator by ByteDance with dance video creation, motion generation, and diverse style features. Create professional AI dance videos for free on 微鲤AI platform.',
        pageKeywords: 'Seedance, AI video generator, dance video creation, motion generation, music synchronization, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'a new AI video generation model launched by ByteDance',
        generatorDescriptionText2: ', formed by the merger of Pixeldance and Seedweed development teams. Seedance 1.0 recently ',
        generatorDescriptionHighlight2: 'ranks first on the Video Arena leaderboard',
        generatorDescriptionText3: '. The tool features ',
        generatorDescriptionHighlight3: 'multi-shot capabilities, smooth and directed camera movement',
        generatorDescriptionText4: ' and more! Use ',
        generatorDescriptionHighlight4: 'Seedance on 微鲤AI to create AI videos',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Accurate Semantic Understanding',
        accurateSemanticDescription: 'Precisely interprets complex user prompts',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamic Camera Control',
        dynamicCameraControlDescription: 'Including zoom, pan, and tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-Shot Generation with Consistency',
        multiShotGenerationDescription: 'Generates multiple shots while maintaining consistency',

        // Support for multiple styles
        multipleStylesTitle: 'Support for Multiple Styles',
        multipleStylesDescription: 'Supports various artistic styles and themes',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Seedance Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Seedance" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Dance Creative Ideas',
        step2Description: 'Describe the dance style and movements you want to generate, or upload reference images, and choose your preferred music and rhythm.',
        step3Title: 'Download Your Dance Video',
        step3Description: 'Click "Create" to download or share the generated spectacular dance video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Seedance?',
        faq1Answer: 'Seedance is an innovative AI video generation platform focused on dance video creation and motion generation. It uses advanced deep learning technology to generate smooth, natural dance and motion video content.',
        faq2Question: 'What are the main features of Seedance?',
        faq2Answer: 'Seedance\'s main features include: dance video creation, motion generation, diverse styles, music synchronization, etc. It is specially optimized for dance video generation and supports various dance styles, from classical ballet to modern street dance.',
        faq3Question: 'Can I use Seedance for free?',
        faq3Answer: 'Yes. Seedance provides limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What dance styles does Seedance support?',
        faq4Answer: 'Seedance supports various dance and motion styles, including classical dance, modern dance, street dance, folk dance, etc., allowing you to create diverse and spectacular video content.',
        faq5Question: 'Can I use Seedance for professional or commercial projects?',
        faq5Answer: 'Yes. Seedance\'s high-quality dance video generation and powerful motion generation capabilities make it a strong choice for professional dance creators, content creators, and commercial users.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance now and transform your dance ideas into amazing videos',
        ctaButton: 'Try Seedance on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Video Seedance 1.0 Pro - Creación de Videos de Danza con IA',
        pageDescription: 'Experimenta el generador de video Seedance de ByteDance con creación de videos de danza, generación de movimientos y características de estilos diversos. Crea videos de danza IA profesionales gratis en la plataforma 微鲤AI.',
        pageKeywords: 'Seedance, generador de video IA, creación de video de danza, generación de movimiento, sincronización musical, video IA gratis, 微鲤AI, producción de video',
    
        // Sección del generador
        generatorTitle: 'Generador de Video Seedance 1.0 Pro',
        generatorDescription: 'Seedance es ',
        generatorDescriptionHighlight1: 'un nuevo modelo de generación de video IA lanzado por ByteDance',
        generatorDescriptionText2: ', formado por la fusión de los equipos de desarrollo de Pixeldance y Seedweed. Seedance 1.0 recientemente ',
        generatorDescriptionHighlight2: 'ocupa el primer lugar en la clasificación de Video Arena',
        generatorDescriptionText3: '. ¡La herramienta cuenta con ',
        generatorDescriptionHighlight3: 'capacidades multi-toma, movimiento de cámara suave y dirigido',
        generatorDescriptionText4: ' y más! Usa ',
        generatorDescriptionHighlight4: 'Seedance en 微鲤AI para crear videos IA',
        generatorDescriptionEnd: '.',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
    
        // Sección de características principales
        coreFeaturesTitle: 'Funciones Principales de Seedance 1.0 Pro',
    
        // Comprensión semántica precisa
        accurateSemanticTitle: 'Comprensión Semántica Precisa',
        accurateSemanticDescription: 'Interpreta con precisión prompts complejos de usuarios',
    
        // Control dinámico de cámara
        dynamicCameraControlTitle: 'Control Dinámico de Cámara',
        dynamicCameraControlDescription: 'Incluye zoom, paneo y seguimiento',
    
        // Generación multi-toma con consistencia
        multiShotGenerationTitle: 'Generación Multi-Toma con Consistencia',
        multiShotGenerationDescription: 'Genera múltiples tomas manteniendo la consistencia',
    
        // Soporte para múltiples estilos
        multipleStylesTitle: 'Soporte para Múltiples Estilos',
        multipleStylesDescription: 'Soporta varios estilos artísticos y temas',
    
        // Sección cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Seedance',
        step1Description: 'Ve a la página "Generación de Video IA", luego haz clic en "Seedance" en el menú desplegable de modelos.',
        step1DescriptionHighlight: 'Generación de Video IA',
        step2Title: 'Introduce Tus Ideas Creativas de Danza',
        step2Description: 'Describe el estilo de danza y movimientos que deseas generar, o sube imágenes de referencia, y elige tu música y ritmo preferidos.',
        step3Title: 'Descarga Tu Video de Danza',
        step3Description: 'Haz clic en "Crear" para descargar o compartir el espectacular video de danza generado.',
    
        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo Seedance',
    
        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones Populares de X sobre el Modelo Seedance',
    
        // Sección explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        seedanceProFastTitle: 'Generador de Video IA Seedance 1.0 Pro Fast',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        runwayTitle: 'Generador de Video IA Runway',
    
        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Seedance?',
        faq1Answer: 'Seedance es una plataforma innovadora de generación de video IA enfocada en creación de videos de danza y generación de movimiento. Utiliza tecnología avanzada de aprendizaje profundo para generar contenido de video de danza y movimiento suave y natural.',
        faq2Question: '¿Cuáles son las características principales de Seedance?',
        faq2Answer: 'Las características principales de Seedance incluyen: creación de videos de danza, generación de movimiento, estilos diversos, sincronización musical, etc. Está especialmente optimizado para generación de videos de danza y soporta varios estilos de danza, desde ballet clásico hasta danza urbana moderna.',
        faq3Question: '¿Puedo usar Seedance gratis?',
        faq3Answer: 'Sí. Seedance proporciona créditos gratuitos limitados a través de la prueba gratuita de 微鲤AI. Para uso extensivo, se requiere una actualización.',
        faq4Question: '¿Qué estilos de danza soporta Seedance?',
        faq4Answer: 'Seedance soporta varios estilos de danza y movimiento, incluyendo danza clásica, danza moderna, danza urbana, danza folclórica, etc., permitiéndote crear contenido de video diverso y espectacular.',
        faq5Question: '¿Puedo usar Seedance para proyectos profesionales o comerciales?',
        faq5Answer: 'Sí. La generación de videos de danza de alta calidad y las poderosas capacidades de generación de movimiento de Seedance lo convierten en una opción sólida para creadores de danza profesionales, creadores de contenido y usuarios comerciales.',
    
        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Seedance ahora y transforma tus ideas de danza en videos increíbles',
        ctaButton: 'Prueba Seedance en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur de Vidéo Seedance 1.0 Pro - Création de Vidéos de Danse IA',
        pageDescription: 'Découvrez le générateur de vidéo Seedance de ByteDance avec création de vidéos de danse, génération de mouvements et fonctionnalités de styles divers. Créez des vidéos de danse IA professionnelles gratuitement sur la plateforme 微鲤AI.',
        pageKeywords: 'Seedance, générateur de vidéo IA, création de vidéo de danse, génération de mouvement, synchronisation musicale, vidéo IA gratuite, 微鲤AI, production vidéo',
    
        // Section du générateur
        generatorTitle: 'Générateur de Vidéo Seedance 1.0 Pro',
        generatorDescription: 'Seedance est ',
        generatorDescriptionHighlight1: 'un nouveau modèle de génération de vidéo IA lancé par ByteDance',
        generatorDescriptionText2: ', formé par la fusion des équipes de développement Pixeldance et Seedweed. Seedance 1.0 a récemment ',
        generatorDescriptionHighlight2: 'occupé la première place du classement Video Arena',
        generatorDescriptionText3: '. L\'outil dispose de ',
        generatorDescriptionHighlight3: 'capacités multi-plans, mouvements de caméra fluides et dirigés',
        generatorDescriptionText4: ' et plus encore ! Utilisez ',
        generatorDescriptionHighlight4: 'Seedance sur 微鲤AI pour créer des vidéos IA',
        generatorDescriptionEnd: '.',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',
    
        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Seedance 1.0 Pro',
    
        // Compréhension sémantique précise
        accurateSemanticTitle: 'Compréhension Sémantique Précise',
        accurateSemanticDescription: 'Interprète avec précision les prompts complexes des utilisateurs',
    
        // Contrôle dynamique de la caméra
        dynamicCameraControlTitle: 'Contrôle Dynamique de la Caméra',
        dynamicCameraControlDescription: 'Y compris zoom, panoramique et suivi',
    
        // Génération multi-plans avec cohérence
        multiShotGenerationTitle: 'Génération Multi-Plans avec Cohérence',
        multiShotGenerationDescription: 'Génère plusieurs plans tout en maintenant la cohérence',
    
        // Support de plusieurs styles
        multipleStylesTitle: 'Support de Plusieurs Styles',
        multipleStylesDescription: 'Prend en charge divers styles artistiques et thèmes',
    
        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Seedance',
        step1Description: 'Allez à la page "Génération Vidéo IA", puis cliquez sur "Seedance" dans le menu déroulant des modèles.',
        step1DescriptionHighlight: 'Génération Vidéo IA',
        step2Title: 'Saisissez Vos Idées Créatives de Danse',
        step2Description: 'Décrivez le style de danse et les mouvements que vous souhaitez générer, ou téléchargez des images de référence, et choisissez votre musique et rythme préférés.',
        step3Title: 'Téléchargez Votre Vidéo de Danse',
        step3Description: 'Cliquez sur "Créer" pour télécharger ou partager la vidéo de danse spectaculaire générée.',
    
        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Seedance',
    
        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Seedance',
    
        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        seedanceProFastTitle: 'Générateur de Vidéo IA Seedance 1.0 Pro Fast',
        sora2Title: 'Générateur de Vidéo IA OpenAI Sora-2',
        runwayTitle: 'Générateur de Vidéo IA Runway',
    
        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce que Seedance ?',
        faq1Answer: 'Seedance est une plateforme innovante de génération de vidéo IA axée sur la création de vidéos de danse et la génération de mouvements. Elle utilise une technologie avancée d\'apprentissage profond pour générer du contenu vidéo de danse et de mouvement fluide et naturel.',
        faq2Question: 'Quelles sont les caractéristiques principales de Seedance ?',
        faq2Answer: 'Les caractéristiques principales de Seedance incluent : création de vidéos de danse, génération de mouvements, styles divers, synchronisation musicale, etc. Elle est spécialement optimisée pour la génération de vidéos de danse et prend en charge divers styles de danse, du ballet classique à la danse urbaine moderne.',
        faq3Question: 'Puis-je utiliser Seedance gratuitement ?',
        faq3Answer: 'Oui. Seedance fournit des crédits gratuits limités via l\'essai gratuit de 微鲤AI. Pour une utilisation extensive, une mise à niveau est nécessaire.',
        faq4Question: 'Quels styles de danse Seedance prend-il en charge ?',
        faq4Answer: 'Seedance prend en charge divers styles de danse et de mouvement, y compris la danse classique, la danse moderne, la danse urbaine, la danse folklorique, etc., vous permettant de créer un contenu vidéo diversifié et spectaculaire.',
        faq5Question: 'Puis-je utiliser Seedance pour des projets professionnels ou commerciaux ?',
        faq5Answer: 'Oui. La génération de vidéos de danse de haute qualité et les puissantes capacités de génération de mouvements de Seedance en font un choix solide pour les créateurs de danse professionnels, les créateurs de contenu et les utilisateurs commerciaux.',
    
        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Seedance maintenant et transformez vos idées de danse en vidéos incroyables',
        ctaButton: 'Essayez Seedance sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Videogenerator - KI-Tanzvideo-Erstellung',
        pageDescription: 'Erleben Sie den Seedance Videogenerator von ByteDance mit Tanzvideo-Erstellung, Bewegungsgenerierung und vielfältigen Stilfunktionen. Erstellen Sie kostenlos professionelle KI-Tanzvideos auf der 微鲤AI-Plattform.',
        pageKeywords: 'Seedance, KI-Videogenerator, Tanzvideo-Erstellung, Bewegungsgenerierung, Musiksynchronisation, kostenloses KI-Video, 微鲤AI, Videoproduktion',
    
        // Generator-Abschnitt
        generatorTitle: 'Seedance 1.0 Pro Videogenerator',
        generatorDescription: 'Seedance ist ',
        generatorDescriptionHighlight1: 'ein neues KI-Videogenerierungsmodell, das von ByteDance eingeführt wurde',
        generatorDescriptionText2: ', gebildet durch die Fusion der Pixeldance- und Seedweed-Entwicklungsteams. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'belegt kürzlich den ersten Platz auf der Video Arena-Bestenliste',
        generatorDescriptionText3: '. Das Tool verfügt über ',
        generatorDescriptionHighlight3: 'Multi-Shot-Funktionen, flüssige und gerichtete Kamerabewegungen',
        generatorDescriptionText4: ' und mehr! Verwenden Sie ',
        generatorDescriptionHighlight4: 'Seedance auf 微鲤AI, um KI-Videos zu erstellen',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
    
        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Hauptfunktionen von Seedance 1.0 Pro',
    
        // Präzises semantisches Verständnis
        accurateSemanticTitle: 'Präzises Semantisches Verständnis',
        accurateSemanticDescription: 'Interpretiert präzise komplexe Benutzer-Prompts',
    
        // Dynamische Kamerasteuerung
        dynamicCameraControlTitle: 'Dynamische Kamerasteuerung',
        dynamicCameraControlDescription: 'Einschließlich Zoom, Schwenk und Verfolgung',
    
        // Multi-Shot-Generierung mit Konsistenz
        multiShotGenerationTitle: 'Multi-Shot-Generierung mit Konsistenz',
        multiShotGenerationDescription: 'Generiert mehrere Aufnahmen bei gleichzeitiger Beibehaltung der Konsistenz',
    
        // Unterstützung mehrerer Stile
        multipleStylesTitle: 'Unterstützung Mehrerer Stile',
        multipleStylesDescription: 'Unterstützt verschiedene künstlerische Stile und Themen',
    
        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        step1Title: 'Seedance Modell Auswählen',
        step1Description: 'Gehen Sie zur Seite "KI-Videogenerierung" und klicken Sie dann auf "Seedance" im Modell-Dropdown-Menü.',
        step1DescriptionHighlight: 'KI-Videogenerierung',
        step2Title: 'Geben Sie Ihre Kreativen Tanzideen Ein',
        step2Description: 'Beschreiben Sie den Tanzstil und die Bewegungen, die Sie generieren möchten, oder laden Sie Referenzbilder hoch und wählen Sie Ihre bevorzugte Musik und Ihren Rhythmus.',
        step3Title: 'Laden Sie Ihr Tanzvideo Herunter',
        step3Description: 'Klicken Sie auf "Erstellen", um das generierte spektakuläre Tanzvideo herunterzuladen oder zu teilen.',
    
        // YouTube-Videos-Abschnitt
        youtubeTitle: 'YouTube-Videos über das Seedance Modell',
    
        // X-Beiträge-Abschnitt
        xPostsTitle: 'Beliebte X-Beiträge über das Seedance Modell',
    
        // Andere Modelle erkunden-Abschnitt
        exploreModelsTitle: 'Andere Modelle Erkunden',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast KI-Videogenerator',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
    
        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Seedance?',
        faq1Answer: 'Seedance ist eine innovative KI-Videogenerierungsplattform, die sich auf Tanzvideo-Erstellung und Bewegungsgenerierung konzentriert. Sie verwendet fortschrittliche Deep-Learning-Technologie, um flüssige, natürliche Tanz- und Bewegungsvideoinhalte zu generieren.',
        faq2Question: 'Was sind die Hauptfunktionen von Seedance?',
        faq2Answer: 'Die Hauptfunktionen von Seedance umfassen: Tanzvideo-Erstellung, Bewegungsgenerierung, vielfältige Stile, Musiksynchronisation usw. Sie ist speziell für Tanzvideogenerierung optimiert und unterstützt verschiedene Tanzstile, von klassischem Ballett bis zu modernem Streetdance.',
        faq3Question: 'Kann ich Seedance kostenlos verwenden?',
        faq3Answer: 'Ja. Seedance bietet begrenzte kostenlose Credits über die kostenlose Testversion von 微鲤AI. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Tanzstile unterstützt Seedance?',
        faq4Answer: 'Seedance unterstützt verschiedene Tanz- und Bewegungsstile, einschließlich klassischen Tanz, modernen Tanz, Streetdance, Volkstanz usw., sodass Sie vielfältige und spektakuläre Videoinhalte erstellen können.',
        faq5Question: 'Kann ich Seedance für professionelle oder kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Seedances hochwertige Tanzvideogenerierung und leistungsstarke Bewegungsgenerierungsfähigkeiten machen es zu einer soliden Wahl für professionelle Tanzkreative, Content-Ersteller und kommerzielle Benutzer.',
    
        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Seedance jetzt und verwandeln Sie Ihre Tanzideen in erstaunliche Videos',
        ctaButton: 'Testen Sie Seedance auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Генератор видео Seedance 1.0 Pro - Создание танцевальных видео с ИИ',
        pageDescription: 'Испытайте генератор видео Seedance от ByteDance с созданием танцевальных видео, генерацией движений и функциями разнообразных стилей. Создавайте профессиональные танцевальные видео с ИИ бесплатно на платформе 微鲤AI.',
        pageKeywords: 'Seedance, генератор видео ИИ, создание танцевального видео, генерация движений, синхронизация музыки, бесплатное видео ИИ, 微鲤AI, производство видео',
    
        // Раздел генератора
        generatorTitle: 'Генератор видео Seedance 1.0 Pro',
        generatorDescription: 'Seedance - это ',
        generatorDescriptionHighlight1: 'новая модель генерации видео с ИИ, запущенная ByteDance',
        generatorDescriptionText2: ', сформированная слиянием команд разработки Pixeldance и Seedweed. Seedance 1.0 недавно ',
        generatorDescriptionHighlight2: 'занял первое место в рейтинге Video Arena',
        generatorDescriptionText3: '. Инструмент имеет ',
        generatorDescriptionHighlight3: 'возможности мультикадра, плавное и направленное движение камеры',
        generatorDescriptionText4: ' и многое другое! Используйте ',
        generatorDescriptionHighlight4: 'Seedance на 微鲤AI для создания видео с ИИ',
        generatorDescriptionEnd: '.',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',
    
        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Seedance 1.0 Pro',
    
        // Точное семантическое понимание
        accurateSemanticTitle: 'Точное семантическое понимание',
        accurateSemanticDescription: 'Точно интерпретирует сложные пользовательские промпты',
    
        // Динамическое управление камерой
        dynamicCameraControlTitle: 'Динамическое управление камерой',
        dynamicCameraControlDescription: 'Включая масштабирование, панорамирование и отслеживание',
    
        // Мультикадровая генерация с последовательностью
        multiShotGenerationTitle: 'Мультикадровая генерация с последовательностью',
        multiShotGenerationDescription: 'Генерирует несколько кадров, сохраняя последовательность',
    
        // Поддержка нескольких стилей
        multipleStylesTitle: 'Поддержка нескольких стилей',
        multipleStylesDescription: 'Поддерживает различные художественные стили и темы',
    
        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        step1Title: 'Выберите модель Seedance',
        step1Description: 'Перейдите на страницу "Генерация видео с ИИ", затем нажмите "Seedance" в выпадающем меню моделей.',
        step1DescriptionHighlight: 'Генерация видео с ИИ',
        step2Title: 'Введите ваши творческие танцевальные идеи',
        step2Description: 'Опишите стиль танца и движения, которые вы хотите сгенерировать, или загрузите референсные изображения и выберите предпочитаемую музыку и ритм.',
        step3Title: 'Скачайте ваше танцевальное видео',
        step3Description: 'Нажмите "Создать", чтобы скачать или поделиться сгенерированным зрелищным танцевальным видео.',
    
        // Раздел видео на YouTube
        youtubeTitle: 'Видео на YouTube о модели Seedance',
    
        // Раздел постов X
        xPostsTitle: 'Популярные посты X о модели Seedance',
    
        // Раздел исследования других моделей
        exploreModelsTitle: 'Исследовать другие модели',
        seedanceProFastTitle: 'Генератор видео ИИ Seedance 1.0 Pro Fast',
        sora2Title: 'Генератор видео ИИ OpenAI Sora-2',
        runwayTitle: 'Генератор видео ИИ Runway',
    
        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Seedance?',
        faq1Answer: 'Seedance - это инновационная платформа генерации видео с ИИ, ориентированная на создание танцевальных видео и генерацию движений. Она использует передовую технологию глубокого обучения для создания плавного, естественного танцевального и двигательного видеоконтента.',
        faq2Question: 'Каковы основные функции Seedance?',
        faq2Answer: 'Основные функции Seedance включают: создание танцевальных видео, генерацию движений, разнообразные стили, синхронизацию музыки и т.д. Она специально оптимизирована для генерации танцевальных видео и поддерживает различные танцевальные стили, от классического балета до современного уличного танца.',
        faq3Question: 'Могу ли я использовать Seedance бесплатно?',
        faq3Answer: 'Да. Seedance предоставляет ограниченные бесплатные кредиты через бесплатную пробную версию 微鲤AI. Для обширного использования требуется обновление.',
        faq4Question: 'Какие танцевальные стили поддерживает Seedance?',
        faq4Answer: 'Seedance поддерживает различные танцевальные и двигательные стили, включая классический танец, современный танец, уличный танец, народный танец и т.д., позволяя вам создавать разнообразный и зрелищный видеоконтент.',
        faq5Question: 'Могу ли я использовать Seedance для профессиональных или коммерческих проектов?',
        faq5Answer: 'Да. Высококачественная генерация танцевальных видео и мощные возможности генерации движений Seedance делают его надежным выбором для профессиональных танцевальных креаторов, создателей контента и коммерческих пользователей.',
    
        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Seedance сейчас и превратите ваши танцевальные идеи в потрясающие видео',
        ctaButton: 'Попробуйте Seedance на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Vídeo Seedance 1.0 Pro - Criação de Vídeos de Dança com IA',
        pageDescription: 'Experimente o gerador de vídeo Seedance da ByteDance com criação de vídeos de dança, geração de movimentos e recursos de estilos diversos. Crie vídeos de dança IA profissionais gratuitamente na plataforma 微鲤AI.',
        pageKeywords: 'Seedance, gerador de vídeo IA, criação de vídeo de dança, geração de movimento, sincronização musical, vídeo IA grátis, 微鲤AI, produção de vídeo',
    
        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Seedance 1.0 Pro',
        generatorDescription: 'Seedance é ',
        generatorDescriptionHighlight1: 'um novo modelo de geração de vídeo IA lançado pela ByteDance',
        generatorDescriptionText2: ', formado pela fusão das equipes de desenvolvimento Pixeldance e Seedweed. Seedance 1.0 recentemente ',
        generatorDescriptionHighlight2: 'ocupa o primeiro lugar no ranking da Video Arena',
        generatorDescriptionText3: '. A ferramenta apresenta ',
        generatorDescriptionHighlight3: 'capacidades multi-shot, movimento de câmera suave e direcionado',
        generatorDescriptionText4: ' e muito mais! Use ',
        generatorDescriptionHighlight4: 'Seedance no 微鲤AI para criar vídeos IA',
        generatorDescriptionEnd: '.',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
    
        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Seedance 1.0 Pro',
    
        // Compreensão semântica precisa
        accurateSemanticTitle: 'Compreensão Semântica Precisa',
        accurateSemanticDescription: 'Interpreta com precisão prompts complexos de usuários',
    
        // Controle dinâmico de câmera
        dynamicCameraControlTitle: 'Controle Dinâmico de Câmera',
        dynamicCameraControlDescription: 'Incluindo zoom, pan e rastreamento',
    
        // Geração multi-shot com consistência
        multiShotGenerationTitle: 'Geração Multi-Shot com Consistência',
        multiShotGenerationDescription: 'Gera múltiplos shots mantendo a consistência',
    
        // Suporte para múltiplos estilos
        multipleStylesTitle: 'Suporte para Múltiplos Estilos',
        multipleStylesDescription: 'Suporta vários estilos artísticos e temas',
    
        // Seção como usar
        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Seedance',
        step1Description: 'Vá para a página "Geração de Vídeo IA", depois clique em "Seedance" no menu suspenso de modelos.',
        step1DescriptionHighlight: 'Geração de Vídeo IA',
        step2Title: 'Insira Suas Ideias Criativas de Dança',
        step2Description: 'Descreva o estilo de dança e movimentos que deseja gerar, ou faça upload de imagens de referência, e escolha sua música e ritmo preferidos.',
        step3Title: 'Baixe Seu Vídeo de Dança',
        step3Description: 'Clique em "Criar" para baixar ou compartilhar o vídeo de dança espetacular gerado.',
    
        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo Seedance',
    
        // Seção de publicações X
        xPostsTitle: 'Publicações Populares do X sobre o Modelo Seedance',
    
        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        seedanceProFastTitle: 'Gerador de Vídeo IA Seedance 1.0 Pro Fast',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        runwayTitle: 'Gerador de Vídeo IA Runway',
    
        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Seedance?',
        faq1Answer: 'Seedance é uma plataforma inovadora de geração de vídeo IA focada em criação de vídeos de dança e geração de movimentos. Ela usa tecnologia avançada de aprendizado profundo para gerar conteúdo de vídeo de dança e movimento suave e natural.',
        faq2Question: 'Quais são os recursos principais do Seedance?',
        faq2Answer: 'Os recursos principais do Seedance incluem: criação de vídeos de dança, geração de movimento, estilos diversos, sincronização musical, etc. É especialmente otimizado para geração de vídeos de dança e suporta vários estilos de dança, desde balé clássico até dança urbana moderna.',
        faq3Question: 'Posso usar o Seedance gratuitamente?',
        faq3Answer: 'Sim. O Seedance fornece créditos gratuitos limitados através do teste gratuito do 微鲤AI. Para uso extensivo, é necessária uma atualização.',
        faq4Question: 'Quais estilos de dança o Seedance suporta?',
        faq4Answer: 'O Seedance suporta vários estilos de dança e movimento, incluindo dança clássica, dança moderna, dança urbana, dança folclórica, etc., permitindo que você crie conteúdo de vídeo diverso e espetacular.',
        faq5Question: 'Posso usar o Seedance para projetos profissionais ou comerciais?',
        faq5Answer: 'Sim. A geração de vídeos de dança de alta qualidade e as poderosas capacidades de geração de movimento do Seedance o tornam uma escolha sólida para criadores de dança profissionais, criadores de conteúdo e usuários comerciais.',
    
        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Seedance agora e transforme suas ideias de dança em vídeos incríveis',
        ctaButton: 'Experimente o Seedance no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Video Seedance 1.0 Pro - Creazione di Video di Danza con IA',
        pageDescription: 'Scopri il generatore di video Seedance di ByteDance con creazione di video di danza, generazione di movimenti e funzionalità di stili diversi. Crea video di danza IA professionali gratuitamente sulla piattaforma 微鲤AI.',
        pageKeywords: 'Seedance, generatore video IA, creazione video danza, generazione movimento, sincronizzazione musicale, video IA gratuito, 微鲤AI, produzione video',
    
        // Sezione generatore
        generatorTitle: 'Generatore di Video Seedance 1.0 Pro',
        generatorDescription: 'Seedance è ',
        generatorDescriptionHighlight1: 'un nuovo modello di generazione video IA lanciato da ByteDance',
        generatorDescriptionText2: ', formato dalla fusione dei team di sviluppo Pixeldance e Seedweed. Seedance 1.0 recentemente ',
        generatorDescriptionHighlight2: 'si classifica al primo posto nella classifica Video Arena',
        generatorDescriptionText3: '. Lo strumento presenta ',
        generatorDescriptionHighlight3: 'capacità multi-inquadratura, movimento della fotocamera fluido e diretto',
        generatorDescriptionText4: ' e altro ancora! Usa ',
        generatorDescriptionHighlight4: 'Seedance su 微鲤AI per creare video IA',
        generatorDescriptionEnd: '.',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',
    
        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Seedance 1.0 Pro',
    
        // Comprensione semantica accurata
        accurateSemanticTitle: 'Comprensione Semantica Accurata',
        accurateSemanticDescription: 'Interpreta con precisione prompt utente complessi',
    
        // Controllo dinamico della fotocamera
        dynamicCameraControlTitle: 'Controllo Dinamico della Fotocamera',
        dynamicCameraControlDescription: 'Inclusi zoom, panoramica e tracciamento',
    
        // Generazione multi-inquadratura con coerenza
        multiShotGenerationTitle: 'Generazione Multi-Inquadratura con Coerenza',
        multiShotGenerationDescription: 'Genera più inquadrature mantenendo la coerenza',
    
        // Supporto per più stili
        multipleStylesTitle: 'Supporto per Più Stili',
        multipleStylesDescription: 'Supporta vari stili artistici e temi',
    
        // Sezione come usare
        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Seedance',
        step1Description: 'Vai alla pagina "Generazione Video IA", quindi clicca su "Seedance" nel menu a discesa dei modelli.',
        step1DescriptionHighlight: 'Generazione Video IA',
        step2Title: 'Inserisci le Tue Idee Creative di Danza',
        step2Description: 'Descrivi lo stile di danza e i movimenti che vuoi generare, o carica immagini di riferimento, e scegli la tua musica e ritmo preferiti.',
        step3Title: 'Scarica il Tuo Video di Danza',
        step3Description: 'Clicca su "Crea" per scaricare o condividere il video di danza spettacolare generato.',
    
        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Seedance',
    
        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Seedance',
    
        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        seedanceProFastTitle: 'Generatore Video IA Seedance 1.0 Pro Fast',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        runwayTitle: 'Generatore Video IA Runway',
    
        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è Seedance?',
        faq1Answer: 'Seedance è una piattaforma innovativa di generazione video IA focalizzata sulla creazione di video di danza e generazione di movimenti. Utilizza tecnologia avanzata di deep learning per generare contenuti video di danza e movimento fluidi e naturali.',
        faq2Question: 'Quali sono le caratteristiche principali di Seedance?',
        faq2Answer: 'Le caratteristiche principali di Seedance includono: creazione di video di danza, generazione di movimento, stili diversi, sincronizzazione musicale, ecc. È appositamente ottimizzato per la generazione di video di danza e supporta vari stili di danza, dal balletto classico alla danza urbana moderna.',
        faq3Question: 'Posso usare Seedance gratuitamente?',
        faq3Answer: 'Sì. Seedance fornisce crediti gratuiti limitati attraverso la prova gratuita di 微鲤AI. Per un uso estensivo, è necessario un upgrade.',
        faq4Question: 'Quali stili di danza supporta Seedance?',
        faq4Answer: 'Seedance supporta vari stili di danza e movimento, tra cui danza classica, danza moderna, danza urbana, danza folkloristica, ecc., permettendoti di creare contenuti video diversi e spettacolari.',
        faq5Question: 'Posso usare Seedance per progetti professionali o commerciali?',
        faq5Answer: 'Sì. La generazione di video di danza di alta qualità e le potenti capacità di generazione di movimento di Seedance lo rendono una scelta solida per creatori di danza professionali, creatori di contenuti e utenti commerciali.',
    
        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Prova Seedance ora e trasforma le tue idee di danza in video straordinari',
        ctaButton: 'Prova Seedance su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta la carta di credito',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد الفيديو Seedance 1.0 Pro - إنشاء فيديوهات رقص بالذكاء الاصطناعي',
        pageDescription: 'جرب مولد الفيديو Seedance من ByteDance مع إنشاء فيديوهات الرقص، وتوليد الحركة، وميزات الأنماط المتنوعة. أنشئ فيديوهات رقص احترافية بالذكاء الاصطناعي مجانًا على منصة 微鲤AI.',
        pageKeywords: 'Seedance, مولد فيديو ذكاء اصطناعي, إنشاء فيديو رقص, توليد حركة, مزامنة موسيقية, فيديو ذكاء اصطناعي مجاني, 微鲤AI, إنتاج فيديو',
    
        // قسم المولد
        generatorTitle: 'مولد الفيديو Seedance 1.0 Pro',
        generatorDescription: 'Seedance هو ',
        generatorDescriptionHighlight1: 'نموذج جديد لتوليد الفيديو بالذكاء الاصطناعي أطلقته ByteDance',
        generatorDescriptionText2: '، تشكل من دمج فرق تطوير Pixeldance و Seedweed. Seedance 1.0 مؤخرًا ',
        generatorDescriptionHighlight2: 'يحتل المرتبة الأولى في تصنيف Video Arena',
        generatorDescriptionText3: '. تتميز الأداة بـ ',
        generatorDescriptionHighlight3: 'قدرات متعددة اللقطات، حركة كاميرا سلسة وموجهة',
        generatorDescriptionText4: ' والمزيد! استخدم ',
        generatorDescriptionHighlight4: 'Seedance على 微鲤AI لإنشاء مقاطع فيديو بالذكاء الاصطناعي',
        generatorDescriptionEnd: '.',
        
        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
    
        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Seedance 1.0 Pro',
    
        // الفهم الدلالي الدقيق
        accurateSemanticTitle: 'فهم دلالي دقيق',
        accurateSemanticDescription: 'يفسر بدقة المطالبات المعقدة للمستخدمين',
    
        // التحكم الديناميكي في الكاميرا
        dynamicCameraControlTitle: 'تحكم ديناميكي في الكاميرا',
        dynamicCameraControlDescription: 'بما في ذلك التكبير والتحريك والتتبع',
    
        // توليد متعدد اللقطات مع الاتساق
        multiShotGenerationTitle: 'توليد متعدد اللقطات مع الاتساق',
        multiShotGenerationDescription: 'يولد عدة لقطات مع الحفاظ على الاتساق',
    
        // دعم أنماط متعددة
        multipleStylesTitle: 'دعم أنماط متعددة',
        multipleStylesDescription: 'يدعم أنماط فنية ومواضيع مختلفة',
    
        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'اختر نموذج Seedance',
        step1Description: 'انتقل إلى صفحة "توليد الفيديو بالذكاء الاصطناعي"، ثم انقر على "Seedance" في القائمة المنسدلة للنماذج.',
        step1DescriptionHighlight: 'توليد الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل أفكارك الإبداعية للرقص',
        step2Description: 'صف أسلوب الرقص والحركات التي تريد توليدها، أو قم بتحميل صور مرجعية، واختر الموسيقى والإيقاع المفضلين لديك.',
        step3Title: 'قم بتنزيل فيديو الرقص الخاص بك',
        step3Description: 'انقر على "إنشاء" لتنزيل أو مشاركة فيديو الرقص المذهل المُنشأ.',
    
        // قسم فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج Seedance',
    
        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج Seedance',
    
        // قسم استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        seedanceProFastTitle: 'مولد الفيديو بالذكاء الاصطناعي Seedance 1.0 Pro Fast',
        sora2Title: 'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2',
        runwayTitle: 'مولد الفيديو بالذكاء الاصطناعي Runway',
    
        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Seedance؟',
        faq1Answer: 'Seedance هي منصة مبتكرة لتوليد الفيديو بالذكاء الاصطناعي تركز على إنشاء فيديوهات الرقص وتوليد الحركة. تستخدم تقنية متقدمة للتعلم العميق لتوليد محتوى فيديو رقص وحركة سلس وطبيعي.',
        faq2Question: 'ما هي الميزات الرئيسية لـ Seedance؟',
        faq2Answer: 'تشمل الميزات الرئيسية لـ Seedance: إنشاء فيديوهات الرقص، توليد الحركة، أنماط متنوعة، مزامنة موسيقية، إلخ. تم تحسينها خصيصًا لتوليد فيديوهات الرقص وتدعم أنماط رقص مختلفة، من الباليه الكلاسيكي إلى رقص الشارع الحديث.',
        faq3Question: 'هل يمكنني استخدام Seedance مجانًا؟',
        faq3Answer: 'نعم. يوفر Seedance أرصدة مجانية محدودة من خلال الإصدار التجريبي المجاني من 微鲤AI. للاستخدام المكثف، يلزم الترقية.',
        faq4Question: 'ما أنماط الرقص التي يدعمها Seedance؟',
        faq4Answer: 'يدعم Seedance أنماط رقص وحركة مختلفة، بما في ذلك الرقص الكلاسيكي، الرقص الحديث، رقص الشارع، الرقص الشعبي، إلخ، مما يتيح لك إنشاء محتوى فيديو متنوع ومذهل.',
        faq5Question: 'هل يمكنني استخدام Seedance للمشاريع الاحترافية أو التجارية؟',
        faq5Answer: 'نعم. تجعل توليد فيديوهات الرقص عالية الجودة والقدرات القوية لتوليد الحركة من Seedance خيارًا قويًا لمبدعي الرقص المحترفين ومنشئي المحتوى والمستخدمين التجاريين.',
    
        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Seedance الآن وحوّل أفكارك للرقص إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Seedance على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - การสร้างวิดีโอเต้นด้วย AI',
        pageDescription: 'สัมผัสตัวสร้างวิดีโอ Seedance จาก ByteDance ที่มีฟีเจอร์สร้างวิดีโอเต้น สร้างการเคลื่อนไหว และสไตล์หลากหลาย สร้างวิดีโอเต้น AI ระดับมืออาชีพได้ฟรีบน 微鲤AI.',
        pageKeywords: 'Seedance, ตัวสร้างวิดีโอ AI, การสร้างวิดีโอเต้น, การสร้างการเคลื่อนไหว, ซิงก์เพลง, วิดีโอ AI ฟรี, 微鲤AI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance คือ ',
        generatorDescriptionHighlight1: 'โมเดลสร้างวิดีโอ AI ใหม่ที่เปิดตัวโดย ByteDance',
        generatorDescriptionText2: ', ที่เกิดจากการรวมทีมพัฒนา Pixeldance และ Seedweed. Seedance 1.0 ล่าสุด ',
        generatorDescriptionHighlight2: 'ครองอันดับ 1 บนกระดานผู้นำ Video Arena',
        generatorDescriptionText3: '. เครื่องมือนี้มี ',
        generatorDescriptionHighlight3: 'ความสามารถหลายช็อต การเคลื่อนกล้องลื่นไหลและกำหนดทิศทางได้',
        generatorDescriptionText4: ' และอีกมากมาย! ใช้ ',
        generatorDescriptionHighlight4: 'Seedance บน 微鲤AI เพื่อสร้างวิดีโอ AI',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'ความเข้าใจเชิงความหมายแม่นยำ',
        accurateSemanticDescription: 'ตีความพรอมป์ต์ที่ซับซ้อนได้อย่างแม่นยำ',

        // Dynamic camera control
        dynamicCameraControlTitle: 'การควบคุมกล้องแบบไดนามิก',
        dynamicCameraControlDescription: 'รวมถึงการซูม การแพน และการติดตาม',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'สร้างหลายช็อตอย่างสอดคล้อง',
        multiShotGenerationDescription: 'สร้างหลายช็อตพร้อมรักษาความสม่ำเสมอ',

        // Support for multiple styles
        multipleStylesTitle: 'รองรับหลายสไตล์',
        multipleStylesDescription: 'รองรับสไตล์และธีมศิลป์หลากหลาย',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'เลือกโมเดล Seedance',
        step1Description: 'ไปที่หน้า "การสร้างวิดีโอด้วย AI" แล้วคลิก "Seedance" ในเมนูดรอปดาวน์โมเดล.',
        step1DescriptionHighlight: 'การสร้างวิดีโอด้วย AI',
        step2Title: 'ใส่ไอเดียการเต้นของคุณ',
        step2Description: 'อธิบายสไตล์และท่าทางการเต้นที่ต้องการ หรืออัปโหลดภาพอ้างอิง แล้วเลือกเพลงและจังหวะที่ชอบ.',
        step3Title: 'ดาวน์โหลดวิดีโอเต้นของคุณ',
        step3Description: 'คลิก "Create" เพื่อดาวน์โหลดหรือแชร์วิดีโอเต้นที่สร้างขึ้น.',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Seedance',

        // X Posts section
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับโมเดล Seedance',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast ตัวสร้างวิดีโอ AI',
        sora2Title: 'OpenAI Sora-2 ตัวสร้างวิดีโอ AI',
        runwayTitle: 'Runway ตัวสร้างวิดีโอ AI',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Seedance คืออะไร?',
        faq1Answer: 'Seedance เป็นแพลตฟอร์มสร้างวิดีโอ AI ที่เน้นการสร้างวิดีโอเต้นและการสร้างการเคลื่อนไหว ใช้เทคโนโลยีดีปเลิร์นนิงขั้นสูงเพื่อสร้างคอนเทนต์การเต้นที่ลื่นไหลและเป็นธรรมชาติ.',
        faq2Question: 'ฟีเจอร์หลักของ Seedance มีอะไรบ้าง?',
        faq2Answer: 'ฟีเจอร์หลักของ Seedance ได้แก่ การสร้างวิดีโอเต้น การสร้างการเคลื่อนไหว สไตล์หลากหลาย การซิงก์เพลง ฯลฯ โดยถูกปรับแต่งเฉพาะสำหรับวิดีโอเต้นและรองรับสไตล์ตั้งแต่บัลเลต์คลาสสิกถึงสตรีทแดนซ์สมัยใหม่.',
        faq3Question: 'ใช้ Seedance ฟรีได้ไหม?',
        faq3Answer: 'ได้ Seedance มีเครดิตฟรีจำกัดผ่านการทดลองใช้งานฟรีของ 微鲤AI หากใช้งานมากจำเป็นต้องอัปเกรด.',
        faq4Question: 'Seedance รองรับสไตล์การเต้นใดบ้าง?',
        faq4Answer: 'Seedance รองรับสไตล์การเต้นและการเคลื่อนไหวหลากหลาย เช่น คลาสสิก โมเดิร์น สตรีทแดนซ์ โฟล์กแดนซ์ เป็นต้น ช่วยให้คุณสร้างคอนเทนต์วิดีโอที่หลากหลายและน่าตื่นตา.',
        faq5Question: 'ใช้ Seedance กับงานมืออาชีพหรือเชิงพาณิชย์ได้ไหม?',
        faq5Answer: 'ได้ การสร้างวิดีโอเต้นคุณภาพสูงและความสามารถสร้างการเคลื่อนไหวที่ทรงพลัง ทำให้ Seedance เป็นตัวเลือกที่ดีสำหรับนักสร้างสรรค์มืออาชีพ ครีเอเตอร์ และผู้ใช้เชิงธุรกิจ.',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription: 'ลองใช้ Seedance ตอนนี้และเปลี่ยนไอเดียการเต้นของคุณเป็นวิดีโอสุดพิเศษ',
        ctaButton: 'ลอง Seedance บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansevideoproduktion',
        pageDescription: 'Oplev Seedance-videogeneratoren fra ByteDance med dansevideo-produktion, bevægelsesgenerering og mange stilarter. Skab professionelle AI-dansevideoer gratis på 微鲤AI.',
        pageKeywords: 'Seedance, AI videogenerator, dansevideo, bevægelsesgenerering, musik-synkronisering, gratis AI video, 微鲤AI, videoproduktion',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance er ',
        generatorDescriptionHighlight1: 'en ny AI-videogenereringsmodel lanceret af ByteDance',
        generatorDescriptionText2: ', skabt ved fusionen af udviklingsteamsene Pixeldance og Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'ligger for nylig nr. 1 på Video Arena-leaderboardet',
        generatorDescriptionText3: '. Værktøjet har ',
        generatorDescriptionHighlight3: 'multi-shot-funktioner, glidende og styret kamerabevægelse',
        generatorDescriptionText4: ' og mere! Brug ',
        generatorDescriptionHighlight4: 'Seedance på 微鲤AI til at skabe AI-videoer',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunktioner i Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Præcis semantisk forståelse',
        accurateSemanticDescription: 'Fortolker komplekse brugerprompter præcist',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamisk kamerastyring',
        dynamicCameraControlDescription: 'Inklusive zoom, pan og tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generering med konsistens',
        multiShotGenerationDescription: 'Genererer flere shots og bevarer konsistens',

        // Support for multiple styles
        multipleStylesTitle: 'Understøtter flere stilarter',
        multipleStylesDescription: 'Understøtter forskellige kunstneriske stilarter og temaer',

        // How to use section
        howToUseTitle: 'Sådan bruges',
        step1Title: 'Vælg Seedance-model',
        step1Description: 'Gå til siden "AI Video Generation" og klik derefter på "Seedance" i model-dropdownen.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Indtast dine kreative danseidéer',
        step2Description: 'Beskriv den dansestil og de bevægelser, du vil generere, eller upload referencebilleder, og vælg din foretrukne musik og rytme.',
        step3Title: 'Download din dansevideo',
        step3Description: 'Klik på "Create" for at downloade eller dele den genererede dansevideo.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Seedance-modellen',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Seedance?',
        faq1Answer: 'Seedance er en innovativ AI-videogenereringsplatform med fokus på dansevideoer og bevægelsesgenerering. Den bruger avanceret deep learning til at skabe glatte og naturlige danse- og bevægelsesvideoer.',
        faq2Question: 'Hvad er Seedances vigtigste funktioner?',
        faq2Answer: 'Seedances hovedfunktioner omfatter dansevideo-produktion, bevægelsesgenerering, mange stilarter, musik-synkronisering osv. Den er optimeret til dansevideoer og understøtter alt fra klassisk ballet til moderne street dance.',
        faq3Question: 'Kan jeg bruge Seedance gratis?',
        faq3Answer: 'Ja. Seedance giver begrænsede gratis credits via 微鲤AI\'s gratis prøveperiode. Ved omfattende brug kræves opgradering.',
        faq4Question: 'Hvilke dansestile understøtter Seedance?',
        faq4Answer: 'Seedance understøtter forskellige danse- og bevægelsesstile, herunder klassisk dans, moderne dans, street dance og folkedans, så du kan skabe varieret og imponerende videoindhold.',
        faq5Question: 'Kan jeg bruge Seedance til professionelle eller kommercielle projekter?',
        faq5Answer: 'Ja. Seedances høje kvalitet i dansevideogenerering og stærke bevægelsesgenerering gør den til et solidt valg for professionelle dansere, content creators og kommercielle brugere.',

        // CTA section
        ctaTitle: 'Klar til at skabe?',
        ctaDescription: 'Oplev Seedance nu og forvandl dine danseidéer til fantastiske videoer',
        ctaButton: 'Prøv Seedance på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansevideoproduksjon',
        pageDescription: 'Opplev Seedance-videogeneratoren fra ByteDance med dansevideo-produksjon, bevegelsesgenerering og mange stiler. Lag profesjonelle AI-dansevideoer gratis på 微鲤AI.',
        pageKeywords: 'Seedance, AI videogenerator, dansevideo, bevegelsesgenerering, musikksynkronisering, gratis AI video, 微鲤AI, videoproduksjon',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance er ',
        generatorDescriptionHighlight1: 'en ny AI-videogenereringsmodell lansert av ByteDance',
        generatorDescriptionText2: ', dannet av sammenslåingen av utviklingsteamene Pixeldance og Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'ligger nylig som nr. 1 på Video Arena-leaderboardet',
        generatorDescriptionText3: '. Verktøyet har ',
        generatorDescriptionHighlight3: 'multi-shot-funksjoner, jevn og styrt kamerabevegelse',
        generatorDescriptionText4: ' og mer! Bruk ',
        generatorDescriptionHighlight4: 'Seedance på 微鲤AI for å lage AI-videoer',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunksjoner i Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Presis semantisk forståelse',
        accurateSemanticDescription: 'Tolker komplekse brukerprompter presist',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamisk kamerakontroll',
        dynamicCameraControlDescription: 'Inkluderer zoom, pan og tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generering med konsistens',
        multiShotGenerationDescription: 'Genererer flere shots og opprettholder konsistens',

        // Support for multiple styles
        multipleStylesTitle: 'Støtte for flere stiler',
        multipleStylesDescription: 'Støtter ulike kunstneriske stiler og temaer',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Velg Seedance-modell',
        step1Description: 'Gå til siden "AI Video Generation", og klikk deretter "Seedance" i modellnedtrekket.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Legg inn dine kreative danseideer',
        step2Description: 'Beskriv dansestilen og bevegelsene du vil generere, eller last opp referansebilder, og velg ønsket musikk og rytme.',
        step3Title: 'Last ned dansevideoen',
        step3Description: 'Klikk "Create" for å laste ned eller dele den genererte dansevideoen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Seedance-modellen',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Seedance?',
        faq1Answer: 'Seedance er en innovativ AI-videogenereringsplattform som fokuserer på dansevideoer og bevegelsesgenerering. Den bruker avansert deep learning for å lage jevne, naturlige danse- og bevegelsesvideoer.',
        faq2Question: 'Hva er hovedfunksjonene i Seedance?',
        faq2Answer: 'Seedances hovedfunksjoner inkluderer dansevideo-produksjon, bevegelsesgenerering, mange stiler, musikksynkronisering osv. Den er optimalisert for dansevideoer og støtter alt fra klassisk ballett til moderne street dance.',
        faq3Question: 'Kan jeg bruke Seedance gratis?',
        faq3Answer: 'Ja. Seedance gir begrensede gratis credits via 微鲤AI\'s gratis prøveperiode. For omfattende bruk kreves oppgradering.',
        faq4Question: 'Hvilke dansestiler støtter Seedance?',
        faq4Answer: 'Seedance støtter ulike danse- og bevegelsesstiler, inkludert klassisk dans, moderne dans, street dance og folkedans, slik at du kan lage variert og imponerende videoinnhold.',
        faq5Question: 'Kan jeg bruke Seedance til profesjonelle eller kommersielle prosjekter?',
        faq5Answer: 'Ja. Seedances høye kvalitet i dansevideogenerering og kraftige bevegelsesgenerering gjør den til et sterkt valg for profesjonelle dansekunstnere, content creators og kommersielle brukere.',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaDescription: 'Prøv Seedance nå og gjør danseideene dine om til fantastiske videoer',
        ctaButton: 'Prøv Seedance på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort kreves',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansvideoproductie',
        pageDescription: 'Ervaar de Seedance-videogenerator van ByteDance met dansvideoproductie, bewegingsgeneratie en diverse stijlen. Maak gratis professionele AI-dansvideo\'s op 微鲤AI.',
        pageKeywords: 'Seedance, AI videogenerator, dansvideoproductie, bewegingsgeneratie, muzieksynchronisatie, gratis AI video, 微鲤AI, videoproductie',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'een nieuw AI-videogeneratiemodel gelanceerd door ByteDance',
        generatorDescriptionText2: ', gevormd door de fusie van de ontwikkelteams Pixeldance en Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'staat onlangs op nummer 1 in de Video Arena-ranglijst',
        generatorDescriptionText3: '. De tool biedt ',
        generatorDescriptionHighlight3: 'multi-shot-mogelijkheden, vloeiende en gerichte camerabewegingen',
        generatorDescriptionText4: ' en meer! Gebruik ',
        generatorDescriptionHighlight4: 'Seedance op 微鲤AI om AI-video\'s te maken',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Belangrijkste functies van Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Nauwkeurige semantische begrip',
        accurateSemanticDescription: 'Interpreteert complexe prompts precies',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamische camerabesturing',
        dynamicCameraControlDescription: 'Inclusief zoom, pan en tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generatie met consistentie',
        multiShotGenerationDescription: 'Genereert meerdere shots met behoud van consistentie',

        // Support for multiple styles
        multipleStylesTitle: 'Ondersteuning voor meerdere stijlen',
        multipleStylesDescription: 'Ondersteunt verschillende artistieke stijlen en thema\'s',

        // How to use section
        howToUseTitle: 'Hoe te gebruiken',
        step1Title: 'Selecteer het Seedance-model',
        step1Description: 'Ga naar de pagina "AI Video Generation" en klik vervolgens op "Seedance" in het modeldropdownmenu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Voer je creatieve dansideeën in',
        step2Description: 'Beschrijf de dansstijl en bewegingen die je wilt genereren, of upload referentiebeelden, en kies je favoriete muziek en ritme.',
        step3Title: 'Download je dansvideo',
        step3Description: 'Klik op "Create" om de gegenereerde dansvideo te downloaden of te delen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Seedance-model',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over het Seedance-model',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Seedance?',
        faq1Answer: 'Seedance is een innovatief AI-videogeneratieplatform gericht op dansvideo\'s en bewegingsgeneratie. Het gebruikt geavanceerde deep learning om vloeiende, natuurlijke dans- en bewegingsvideo\'s te maken.',
        faq2Question: 'Wat zijn de belangrijkste functies van Seedance?',
        faq2Answer: 'Belangrijke functies zijn: dansvideoproductie, bewegingsgeneratie, diverse stijlen, muzieksynchronisatie, enz. Het is geoptimaliseerd voor dansvideo\'s en ondersteunt stijlen van klassiek ballet tot moderne streetdance.',
        faq3Question: 'Kan ik Seedance gratis gebruiken?',
        faq3Answer: 'Ja. Seedance biedt beperkte gratis credits via de gratis proefperiode van 微鲤AI. Voor intensief gebruik is een upgrade vereist.',
        faq4Question: 'Welke dansstijlen ondersteunt Seedance?',
        faq4Answer: 'Seedance ondersteunt verschillende dans- en bewegingsstijlen, waaronder klassieke dans, moderne dans, streetdance en volksdans, zodat je divers en spectaculair videomateriaal kunt maken.',
        faq5Question: 'Kan ik Seedance gebruiken voor professionele of commerciële projecten?',
        faq5Answer: 'Ja. De hoge kwaliteit van de dansvideogeneratie en krachtige bewegingsgeneratie maken Seedance een sterke keuze voor professionele dansmakers, content creators en zakelijke gebruikers.',

        // CTA section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaDescription: 'Ervaar Seedance nu en transformeer je dansideeën in geweldige video\'s',
        ctaButton: 'Probeer Seedance op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard nodig',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - Pembuatan Video Tari AI',
        pageDescription: 'Rasakan generator video Seedance dari ByteDance dengan pembuatan video tari, generasi gerak, dan fitur gaya beragam. Buat video tari AI profesional gratis di 微鲤AI.',
        pageKeywords: 'Seedance, generator video AI, pembuatan video tari, generasi gerak, sinkronisasi musik, video AI gratis, 微鲤AI, produksi video',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance adalah ',
        generatorDescriptionHighlight1: 'model generasi video AI baru yang diluncurkan oleh ByteDance',
        generatorDescriptionText2: ', hasil penggabungan tim pengembangan Pixeldance dan Seedweed. Seedance 1.0 baru-baru ini ',
        generatorDescriptionHighlight2: 'menempati peringkat pertama di leaderboard Video Arena',
        generatorDescriptionText3: '. Alat ini memiliki ',
        generatorDescriptionHighlight3: 'kemampuan multi-shot, pergerakan kamera halus dan terarah',
        generatorDescriptionText4: ' dan lainnya! Gunakan ',
        generatorDescriptionHighlight4: 'Seedance di 微鲤AI untuk membuat video AI',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Pemahaman Semantik yang Akurat',
        accurateSemanticDescription: 'Menafsirkan prompt pengguna yang kompleks dengan presisi',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Kontrol Kamera Dinamis',
        dynamicCameraControlDescription: 'Termasuk zoom, pan, dan tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Generasi Multi-Shot yang Konsisten',
        multiShotGenerationDescription: 'Menghasilkan beberapa shot sambil menjaga konsistensi',

        // Support for multiple styles
        multipleStylesTitle: 'Mendukung Banyak Gaya',
        multipleStylesDescription: 'Mendukung berbagai gaya dan tema artistik',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        step1Title: 'Pilih Model Seedance',
        step1Description: 'Buka halaman "AI Video Generation", lalu klik "Seedance" pada menu dropdown model.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Masukkan Ide Kreatif Tarian Anda',
        step2Description: 'Jelaskan gaya tari dan gerakan yang ingin dibuat, atau unggah gambar referensi, lalu pilih musik dan ritme favorit.',
        step3Title: 'Unduh Video Tarian Anda',
        step3Description: 'Klik "Create" untuk mengunduh atau membagikan video tarian spektakuler yang dihasilkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Seedance',

        // X Posts section
        xPostsTitle: 'Posting X Populer tentang Model Seedance',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Lain',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Seedance?',
        faq1Answer: 'Seedance adalah platform generasi video AI inovatif yang berfokus pada pembuatan video tari dan generasi gerak. Teknologi deep learning canggih digunakan untuk menghasilkan konten tari dan gerak yang halus dan alami.',
        faq2Question: 'Apa fitur utama Seedance?',
        faq2Answer: 'Fitur utama Seedance mencakup: pembuatan video tari, generasi gerak, beragam gaya, sinkronisasi musik, dll. Dioptimalkan khusus untuk video tari dan mendukung berbagai gaya, dari balet klasik hingga street dance modern.',
        faq3Question: 'Apakah saya bisa menggunakan Seedance gratis?',
        faq3Answer: 'Ya. Seedance menyediakan kredit gratis terbatas melalui uji coba gratis 微鲤AI. Untuk penggunaan intensif, diperlukan upgrade.',
        faq4Question: 'Gaya tari apa yang didukung Seedance?',
        faq4Answer: 'Seedance mendukung berbagai gaya tari dan gerak, termasuk tari klasik, tari modern, street dance, tari rakyat, dll., sehingga Anda bisa membuat konten video yang beragam dan spektakuler.',
        faq5Question: 'Bisakah Seedance digunakan untuk proyek profesional atau komersial?',
        faq5Answer: 'Ya. Kualitas generasi video tari yang tinggi dan kemampuan generasi gerak yang kuat menjadikan Seedance pilihan tepat bagi kreator tari profesional, content creator, dan pengguna komersial.',

        // CTA section
        ctaTitle: 'Siap Mulai Berkarya?',
        ctaDescription: 'Coba Seedance sekarang dan ubah ide tarian Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Seedance di 微鲤AI',
        ctaDisclaimer: 'Tanpa kartu kredit',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dans Videosu Üretimi',
        pageDescription: 'ByteDance’in Seedance video üreticisiyle dans videosu oluşturma, hareket üretimi ve çeşitli stil özelliklerini deneyimleyin. 微鲤AI’de ücretsiz profesyonel AI dans videoları üretin.',
        pageKeywords: 'Seedance, AI video üretici, dans videosu oluşturma, hareket üretimi, müzik senkronizasyonu, ücretsiz AI video, 微鲤AI, video prodüksiyonu',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance, ',
        generatorDescriptionHighlight1: 'ByteDance tarafından piyasaya sürülen yeni bir AI video üretim modeli',
        generatorDescriptionText2: ' olup Pixeldance ve Seedweed ekiplerinin birleşmesiyle oluşturuldu. Seedance 1.0 yakın zamanda ',
        generatorDescriptionHighlight2: 'Video Arena sıralamasında birinci sırada yer aldı',
        generatorDescriptionText3: '. Araç ',
        generatorDescriptionHighlight3: 'çoklu sahne, akıcı ve yönlendirilmiş kamera hareketi',
        generatorDescriptionText4: ' gibi özellikler sunar! ',
        generatorDescriptionHighlight4: '微鲤AI’de Seedance ile AI videolar oluşturun',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro’nun Temel Özellikleri',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Doğru Anlamsal Anlama',
        accurateSemanticDescription: 'Karmaşık kullanıcı istemlerini hassas şekilde yorumlar',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dinamik Kamera Kontrolü',
        dynamicCameraControlDescription: 'Zoom, pan ve takip dahil',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Tutarlılıkla Çoklu Sahne Üretimi',
        multiShotGenerationDescription: 'Tutarlılığı koruyarak birden fazla sahne üretir',

        // Support for multiple styles
        multipleStylesTitle: 'Birden Fazla Stil Desteği',
        multipleStylesDescription: 'Çeşitli sanatsal stilleri ve temaları destekler',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        step1Title: 'Seedance Modelini Seçin',
        step1Description: '"AI Video Generation" sayfasına gidin ve model açılır menüsünden "Seedance"ı seçin.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Yaratıcı Dans Fikirlerinizi Girin',
        step2Description: 'Üretmek istediğiniz dans stilini ve hareketleri açıklayın veya referans görseller yükleyin, ardından müzik ve ritminizi seçin.',
        step3Title: 'Dans Videonuzu İndirin',
        step3Description: 'Oluşturulan muhteşem dans videosunu indirmek veya paylaşmak için "Create"e tıklayın.',

        // YouTube videos section
        youtubeTitle: 'Seedance Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Seedance Modeli Hakkında Popüler X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Sık Sorulan Sorular',
        faq1Question: 'Seedance nedir?',
        faq1Answer: 'Seedance, dans videosu oluşturma ve hareket üretimine odaklanan yenilikçi bir AI video üretim platformudur. Gelişmiş derin öğrenme teknolojisi ile akıcı ve doğal dans/hareket videoları üretir.',
        faq2Question: 'Seedance’in temel özellikleri nelerdir?',
        faq2Answer: 'Seedance’in temel özellikleri: dans videosu oluşturma, hareket üretimi, çeşitli stiller, müzik senkronizasyonu vb. Dans video üretimine özel olarak optimize edilmiştir ve klasik baleden modern street dance’a kadar birçok stili destekler.',
        faq3Question: 'Seedance’i ücretsiz kullanabilir miyim?',
        faq3Answer: 'Evet. Seedance, 微鲤AI’nin ücretsiz denemesi üzerinden sınırlı ücretsiz kredi sağlar. Yoğun kullanım için yükseltme gerekir.',
        faq4Question: 'Seedance hangi dans stillerini destekler?',
        faq4Answer: 'Seedance; klasik dans, modern dans, street dance, halk dansları gibi çeşitli dans ve hareket stillerini destekler; böylece çeşitli ve etkileyici video içerikleri oluşturabilirsiniz.',
        faq5Question: 'Seedance’i profesyonel veya ticari projelerde kullanabilir miyim?',
        faq5Answer: 'Evet. Seedance’in yüksek kaliteli dans video üretimi ve güçlü hareket üretimi yetenekleri, profesyonel dans yaratıcıları, içerik üreticileri ve ticari kullanıcılar için güçlü bir seçimdir.',

        // CTA section
        ctaTitle: 'Oluşturmaya Hazır mısınız?',
        ctaDescription: 'Seedance’i şimdi deneyin ve dans fikirlerinizi harika videolara dönüştürün',
        ctaButton: '微鲤AI’de Seedance’i Deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
    },
}
